import { AppState } from '@store/state';
import { RetrivedFlightLinkResponse } from '@shared/services/flight/_interfaces_/booked-flight.interface';
import { SelectedFlightResponse } from '@pages/change-flight-confirmation/_interfaces_/change-flight-confirmation.interface';
import { FlightOption, FlightsAndFiltersResponse } from './_interfaces_/result-page.interface';
import { FlightSelectPostPayload } from './_interfaces_/result-page.interface';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { LocalStorageService } from '@shared/services/local-storage/local-storage.service';
import { Observable, Subject, throwError } from 'rxjs';
import { NavigationExtras, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { catchError, map, take } from 'rxjs/operators';
import { UrlService } from '@shared/services/url/url.service';
import { FilterCriteria } from '@shared/services/flight/_interfaces_/flight.interface';
import { ChangeFlightConfirmationService } from '@pages/change-flight-confirmation/change-flight-confirmation.service';
import { UrlPathnameEnum } from '@enums/url-pathname.enum';

@Injectable({
  providedIn: 'root',
})
export class ResultPageService {
  public selectFlightFromModal$ = new Subject<number>();

  constructor(
    @Inject(HttpClient) private _httpClient: HttpClient,
    @Inject(UrlService) private _urlService: UrlService,
    @Inject(Store) private _store: Store<AppState>,
    @Inject(Router) private _router: Router,
    @Inject(LocalStorageService) private _localStorageService: LocalStorageService,
    @Inject(ChangeFlightConfirmationService) private _changeFlightConfirmationService: ChangeFlightConfirmationService
  ) {}

  public getFlightResultList(): Observable<FlightsAndFiltersResponse> {
    const sessionId = this._localStorageService.getUserSessionToken();
    const payload = this._localStorageService.getFlightSearchPayload();
    const url = this._urlService.urls.GET_FLIGHTS_AND_FILTERS;
    const headers = { SessionId: sessionId };
    return this._httpClient.post<FlightsAndFiltersResponse>(url, payload, { headers }).pipe(
      take(1),
      map((response: FlightsAndFiltersResponse) => {
        return response;
      }),
      catchError((error) => {
        this._router.navigate([UrlPathnameEnum.Overview], { replaceUrl: true });
        return throwError(error);
      })
    );
  }

  public filterFlightResultList(identifier: string, payload: FilterCriteria): Observable<FlightsAndFiltersResponse> {
    const sessionId = this._localStorageService.getUserSessionToken();
    const url = this._urlService.urls.GET_FLIGHTS_AND_FILTERS;
    const combinedPayload = {
      FlightIdentifier: identifier,
      ...payload,
    };
    const headers = { SessionId: sessionId };
    return this._httpClient.put<FlightsAndFiltersResponse>(url, combinedPayload, { headers }).pipe(
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  public emitBookFlightFromModal(groupedFlightOptionIndex: number): void {
    this.selectFlightFromModal$.next(groupedFlightOptionIndex);
  }

  public postFlightSelect(payload: FlightSelectPostPayload, sessionId: string): void {
    const headers = { SessionId: sessionId };
    const url = this._urlService.urls.POST_FLIGHT_SELECT;
    this._httpClient
      .post<RetrivedFlightLinkResponse>(url, payload, { headers })
      .pipe(take(1))
      .subscribe((response: SelectedFlightResponse) => {
        this._changeFlightConfirmationService.selectedFlightResponse = response;
        this._router.navigate([UrlPathnameEnum.Confirmation]);
      });
  }
}
